import snippets from './snippets';

const entity = snippets('letterSnippets');

const reducer = entity.reducer;
export {reducer as default, entity};
